import { AnimatedCircularProgressBar } from "components/magicui/animated-circular-progress-bar";
import { useReducedMotion } from "motion/react";
import { useEffect, useState } from "react";

interface KpiRingProps {
	percent: number;
	size?: number;
	primaryColor?: string;
	secondaryColor?: string;
	className?: string;
	"aria-label"?: string;
}

export function KpiRing({
	percent,
	size = 48,
	primaryColor = "var(--ant-color-primary)",
	secondaryColor = "var(--ant-color-fill-secondary)",
	className,
	"aria-label": ariaLabel,
}: KpiRingProps) {
	const reducedMotion = useReducedMotion();
	const clamped = Math.min(100, Math.max(0, percent));
	const [display, setDisplay] = useState(reducedMotion ? clamped : 0);

	useEffect(() => {
		const raf = requestAnimationFrame(() => setDisplay(clamped));
		return () => cancelAnimationFrame(raf);
	}, [clamped]);

	return (
		<AnimatedCircularProgressBar
			value={reducedMotion ? clamped : display}
			gaugePrimaryColor={primaryColor}
			gaugeSecondaryColor={secondaryColor}
			className={className}
			aria-label={ariaLabel}
			style={
				{
					width: size,
					height: size,
					fontSize: Math.round(size * 0.28),
					// Gauge tweens value changes for 1s by default — disable for
					// reduced-motion users.
					...(reducedMotion ? { "--transition-length": "0s" } : {}),
				} as React.CSSProperties
			}
		/>
	);
}
